import { Component, Input } from '@angular/core';

// One-line KPI tile with optional trend pill. Used 17+ times across
// every tab — extracting it removes the bulk of HTML duplication.
@Component({
  selector: 'tangram-analytics-kpi-card',
  templateUrl: './analytics-kpi-card.component.html',
  styleUrls: ['./analytics-kpi-card.component.scss']
})
export class AnalyticsKpiCardComponent {
  @Input() value: string | number = '';
  @Input() label = '';
  @Input() accent = false;
  @Input() trendDelta = 0;
  @Input() trendUnit = '';
  @Input() iconPath: 'document' | 'eye' | 'users' | 'trend-up' | 'clock' | 'grid' | 'chat' | 'check-list' | 'help' | 'calendar' = 'eye';

  get trendLabel(): string {
    if (!this.trendDelta) { return ''; }
    return `${this.trendDelta > 0 ? '+' : ''}${this.trendDelta}${this.trendUnit}`;
  }
}
